export default __webpack_public_path__ + "static/media/single-project-page-01-img11.b805db65.jpg";